module.exports = __webpack_public_path__ + "static/media/spoonerism-task (11).267507b4.mp3";